var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg023SgCarrierPayment = function Svg023SgCarrierPayment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a0eda2",
    d: "M116 248.04V130c0-15.671 9.011-33.438 22.136-40l135.728-65.799C268.488 21.513 262.421 20 256 20s-12.488 1.513-17.864 4.201l-160 80C65.011 110.763 56 124.329 56 140v108.04C56 366.634 139.709 468.742 256 492a250.057 250.057 0 0 0 30-7.974C185.586 450.57 116 356.163 116 248.04z",
    "data-original": "#cee1f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#14d64d",
    d: "M256 316h-40c-11.046 0-20 8.954-20 20s8.954 20 20 20h20v20c0 11.046 8.954 20 20 20s20-8.954 20-20v-23.44c23.278-8.256 40-30.487 40-56.56 0-33.084-26.916-60-60-60-11.028 0-20-8.972-20-20s8.972-20 20-20h40c11.046 0 20-8.954 20-20s-8.954-20-20-20h-20v-20c0-11.046-8.954-20-20-20s-20 8.954-20 20v23.44c-23.278 8.256-40 30.487-40 56.56 0 33.084 26.916 60 60 60 11.028 0 20 8.972 20 20s-8.972 20-20 20z",
    "data-original": "#ff5cf4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#005454",
    d: "M36 140v108.04c0 127.882 90.357 238.428 216.078 263.572a19.984 19.984 0 0 0 7.844 0C385.322 486.531 476 376.251 476 248.04V140c0-22.88-12.719-43.452-33.192-53.687l-159.998-80C274.55 2.183 265.28 0 256 0s-18.55 2.183-26.808 6.313l-159.999 80C48.719 96.548 36 117.12 36 140zm40 0c0-7.63 4.246-14.493 11.081-17.91l160.001-80C249.854 40.703 252.854 40 256 40s6.146.703 8.919 2.09l160 80C431.754 125.507 436 132.37 436 140v108.04c0 107.342-75.461 200.707-180 223.529C151.461 448.747 76 355.382 76 248.04z",
    "data-original": "#0023c4"
  })));
};

export default Svg023SgCarrierPayment;